import React, {FC, useEffect, useState} from 'react';
import DocumentsListPanel from '@/components/Panels/Parcel/Documentation/DocumentsListPanel';
import DocumentAddPanel from '@/components/Panels/Parcel/Documentation/DocumentAddPanel';
import {SelectedParcelMode} from '@/components/Panels/Parcel';
import {DocumentProperties, ParcelDocumentCreation} from '@/domain/entities/ParcelDocument';

//TYPES
export enum DocumentationMode {
  LIST = 'list',
  ADD = 'add'
}
export type DocumentationProps = {
  selectedParcelUuid: string,
  documents?: Array<DocumentProperties>,
  onDocumentUpload: (dataForUpload: ParcelDocumentCreation) => void,
  onDocumentDownload: (dataUrl: string, name: string) => void,
  onDocumentDelete: (uuid: string) => void,
  onSelectedParcelModeChanged: (selectedParcelMode: SelectedParcelMode) => void
};

const Documentation: FC<DocumentationProps> = ({selectedParcelUuid, documents, onDocumentUpload, onDocumentDownload, onDocumentDelete, onSelectedParcelModeChanged}) => {

  const [documentationMode, setDocumentationMode] = useState<DocumentationMode>(DocumentationMode.LIST);

  useEffect(() => {
    if(!documents || !documents.length) setDocumentationMode(DocumentationMode.ADD);
  }, [documents]);

  const handleListExit = () => onSelectedParcelModeChanged(SelectedParcelMode.INFO);
  const handleAddExit = () => setDocumentationMode(DocumentationMode.LIST);

  if(documentationMode === DocumentationMode.LIST) {
    return <DocumentsListPanel
      documents={documents}
      onDocumentDownload={onDocumentDownload}
      onDocumentDelete={onDocumentDelete}
      onSelectedParcelModeChanged={handleListExit}
      onDocumentationModeChanged={setDocumentationMode}
    />;
  }

  if(documentationMode === DocumentationMode.ADD) {
    return <DocumentAddPanel
      selectedParcelUuid={selectedParcelUuid}
      onDocumentUpload={onDocumentUpload}
      onDocumentationModeChanged={handleAddExit}
    />;
  }

};
export default Documentation;